import Input from './InputContainer';

export default Input;



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Input/index.js